import { create } from "zustand";
import _ from "lodash";
import { ApplicationService } from "../services/ApplicationService";
import { VisaApplication } from "../models/VisaApplication";

interface ApplicationStore {
    loading: boolean,
    service: ApplicationService,
    applications: VisaApplication[],
    fetch: (refresh?: boolean) => Promise<VisaApplication[]>
    fetchById: (id: string) => VisaApplication
}

export const useApplicationStore = create<ApplicationStore>()((set, get) => ({
    loading: false,
    service: new ApplicationService(),
    applications: [],
    fetch: async (refresh?: boolean): Promise<VisaApplication[]> => {
        let { applications, loading, service } = get();
        let fetchedData: VisaApplication[] = [];
        if (!loading) {
            if (applications.length <= 0 || refresh) {
                fetchedData = await service.fetchAll();
                fetchedData = _.orderBy(fetchedData, ['createdAt'], ['desc'])
                set({ applications: fetchedData, loading: false })
            }
        }
        return Promise.resolve(applications);
    },
    fetchById: (id: string): any => {
        let { applications, loading, service } = get();
        return applications.find(x => x.id === id);
    },
}))
